import React from "react";

const skillsData = [
  {
    title: "UI/UX Design",
    description:
      "Creates intuitive, user-centered designs through wireframes, prototypes, and high-fidelity visuals. Collaborates with developers to ensure seamless implementation and consistency across digital products.",
  },
  {
    title: "Frontend Development",
    description:
      "Develops responsive and efficient web applications using modern frameworks and technologies. Ensures seamless user interactions through clean, scalable, and maintainable code.",
  },
  {
    title: "Product Design",
    description:
      "Crafts user-centered designs that balance aesthetics and functionality, focusing on the overall product experience.",
  },
  {
    title: "Project Management",
    description:
      "Oversees project timelines, resources, and team coordination to ensure successful delivery within scope and deadlines.",
  },
  {
    title: "Business Development",
    description:
      "Develops and implements strategies to increase revenue, improve customer relationships, and enhance market presence.",
  },
];

const SkillCard = ({ title, description }) => (
  <div className="relative p-4 bg-white border-2 border-gray-500 rounded-2xl space-y-2">
    <h3 className="text-lg font-bold text-gray-800">{title}</h3>
    <p className="text-gray-600">{description}</p>
  </div>
);

const Skills = () => {
  return (
    <div
      className="w-screen py-12 px-6 md:pt-24 md:pb-12 md:px-16 bg-gray-100"
      id="skills"
    >
      <h2 className="text-2xl md:text-4xl text-left md:text-center mb-8 md:mb-12">
        My Skills
      </h2>

      <div className="max-w-5xl mx-auto space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {skillsData.slice(0, 2).map((skill, index) => (
            <SkillCard
              key={index}
              title={skill.title}
              description={skill.description}
            />
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {skillsData.slice(2).map((skill, index) => (
            <SkillCard
              key={index}
              title={skill.title}
              description={skill.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
